import axiosInstance from '../lib/axios';

export interface StorageMissingDocument {
  absolute_path: string;
  relative_path: string;
  file_name: string;
}

export interface StorageSyncItem {
  case_id: string;
  cms_number: string;
  year: number;
  db_document_count: number;
  storage_document_count: number;
  missing_document_count: number;
  case_storage_root: string | null;
  missing_documents: StorageMissingDocument[];
}

export interface StorageSyncReportResponse {
  items: StorageSyncItem[];
  pagination?: { page: number; limit: number; total: number; totalPages: number };
  totals?: { db: number; storage: number; missing: number };
}

export const storageSyncService = {
  getReport: async (params?: {
    q?: string;
    missing_only?: boolean;
    page?: number;
    limit?: number;
  }): Promise<StorageSyncReportResponse> => {
    const res = await axiosInstance.get('/storage-sync/report', { params });
    const items = res.data?.data?.items ?? [];
    const pagination = res.data?.data?.pagination;
    const totals = res.data?.data?.totals;
    return {
      items: Array.isArray(items) ? items : [],
      pagination,
      totals,
    };
  },
  dryRunCase: async (caseId: string) =>
    axiosInstance.post(`/storage-sync/sync-case/${caseId}`, {}, {
      params: { dry_run: true },
    }),
  syncCase: async (caseId: string) =>
    axiosInstance.post(`/storage-sync/sync-case/${caseId}`, {}),
  dryRunAll: async (params?: { q?: string; missing_only?: boolean }) =>
    axiosInstance.post('/storage-sync/sync-all', {}, {
      params: { ...params, dry_run: true },
    }),
  syncAll: async (params?: { q?: string; missing_only?: boolean }) =>
    axiosInstance.post('/storage-sync/sync-all', {}, { params }),
  getStorageFilePreview: async (relativePath: string) => {
    const res = await axiosInstance.get('/storage-sync/file', {
      params: { relative_path: relativePath },
      responseType: 'blob',
    });
    const mimeType =
      (res.headers?.['content-type'] as string | undefined) ||
      'application/octet-stream';
    return {
      blobUrl: URL.createObjectURL(res.data),
      mimeType,
    };
  },
  downloadStorageFile: async (relativePath: string, fileName?: string) => {
    const res = await axiosInstance.get('/storage-sync/file', {
      params: { relative_path: relativePath, download: true },
      responseType: 'blob',
    });
    const blobUrl = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = fileName || 'document';
    a.rel = 'noopener noreferrer';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
  },
};

export default storageSyncService;

